import React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

const Review = () => <Grid fluid>
    <Row center="xs">
        <Col xs={12}>
            <h2>Let Us Know How We're Doing</h2>
            <SelectField floatingLabelText="Service">
                <MenuItem value={1} primaryText="Lawncare" />
            </SelectField>
        </Col>
    </Row>
</Grid>;

export default Review;


// WEBPACK FOOTER //
// ./src/components/Review.js